import { selectedMapEntity } from "$lib/core/map/cesium-entity-store";
import { useCesiumViewer } from "$lib/core/map/cesium-viewer";
import { mapToolsStore } from "$lib/core/map/map-tools-store";
import { setSelectedEntity, toggleEntityVisuals } from "$lib/core/map/map-utils";
import { get } from "svelte/store";
import { SideMenuOptions } from "./constants";
import { useDataSources } from "$lib/core/map/cesium-datasources";
import { removeAllScreenSpaceInputActions } from "$lib/core/map/map-tools";
import { floatingSidemenuState } from "$lib/stores/floating-sidemenu-store";

/**
 * Toggle open/close the side menu.
 * @param option – The sidemenu option clicked.
 */
export const toggleSideMenuOption = (option: keyof typeof SideMenuOptions, disableAllTools: boolean) => {
    const viewer = useCesiumViewer();

    // Make some general functions for when toggling toolbar buttons
    // Should include resetting tool/selection state and temporary datasources. Make exceptions only where necessary
    // The general function may also be a part of mass deactivation of tools.

    if (viewer.selectedEntity) {
        setSelectedEntity(undefined);
        selectedMapEntity.set(undefined);
    }

    if (disableAllTools) {
        // Does not work as intended. E.g. 3D boxes are lingering after drawing menu is closed.
        mapToolsStore.disableAllTools(viewer);
    }

    const selectedMapEntities = get(mapToolsStore).selectedMapEntities;

    if(selectedMapEntities.length > 0){
        toggleEntityVisuals(selectedMapEntities, false);
        mapToolsStore.update((store) => {
            store.selectedMapEntities = [];
            return store;
        });
    }

    const { temporaryConfiguredLinesDataSource } = useDataSources();
    temporaryConfiguredLinesDataSource.entities.removeAll();

    // Clear the datasource for any potentially lingering terrain profile polyline when disabling the tool. no longer applicable;
    // distanceAnalysisTerrainProfilesDataSource.entities.removeAll();
    removeAllScreenSpaceInputActions(viewer, viewer.screenSpaceEventHandler);

    if (get(floatingSidemenuState) !== option) {
        floatingSidemenuState.set(option);
        return;
    }
    floatingSidemenuState.set(SideMenuOptions.NONE);
};